export function checkEmbedCode(embedJs) {
  // Function to decode the Base64 string
  const decodeFromBase64 = (base64String) => {
    try {
      // Convert base64 to a byte array
      const binaryString = base64String
        .replace(/_/g, '/')  // Handle URL-safe base64 encoding variants
        .replace(/-/g, '+'); // Handle URL-safe base64 encoding variants
      const binaryLength = binaryString.length;
      const bytes = new Uint8Array(binaryLength / 4 * 3);

      let byteIndex = 0;
      for (let i = 0; i < binaryLength; i += 4) {
        const encoded1 = getBase64Value(binaryString[i]);
        const encoded2 = getBase64Value(binaryString[i + 1]);
        const encoded3 = getBase64Value(binaryString[i + 2]);
        const encoded4 = getBase64Value(binaryString[i + 3]);

        const byte1 = (encoded1 << 2) | (encoded2 >> 4);
        const byte2 = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        const byte3 = ((encoded3 & 3) << 6) | encoded4;

        bytes[byteIndex++] = byte1;
        if (encoded3 !== 64) bytes[byteIndex++] = byte2;
        if (encoded4 !== 64) bytes[byteIndex++] = byte3;
      }

      const decoder = new TextDecoder('utf-8');
      return decoder.decode(bytes.subarray(0, byteIndex));
    } catch (error) {
      return "Invalid Base64 string";
    }
  };

  // Helper function to find Base64 character index
  const getBase64Value = (character) => {
    if (character === '=') return 64;
    const index = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.indexOf(character);
    return index === -1 ? 0 : index;
  };

  // Function to check for the required div and padding
  const checkFlowplayerDiv = (htmlString) => {
    // Regex to find the div with class "flowplayer-embed-container" and extract the style attribute
    const divMatch = htmlString.match(
      /<div[^>]*class=["'][^"']*flowplayer-embed-container[^"']*["'][^>]*style=["']([^"']*)["'][^>]*>/i
    );
    if (!divMatch) return false;

    // Use the captured style attribute from the regex
    const styleAttr = divMatch[1] || "";
    const match = styleAttr && styleAttr.match(/padding-bottom\s*:\s*([\d]{1,3}(?:\.\d+)?)\s*%/i);
    const paddingBottom = match ? parseFloat(match[1]) : 0;

    return paddingBottom && paddingBottom > 100;
  };

  // Decode the embedded JS code
  let decodedHtml;
  try {
    decodedHtml = decodeFromBase64(embedJs);
  } catch (error) {
    return false; // Return false if decoding fails
  }

  if (decodedHtml === "Invalid Base64 string") {
    return false;
  }

  // Check the decoded HTML for the specified condition
  const isConditionMet = checkFlowplayerDiv(decodedHtml);
  return isConditionMet ? true : false;
};
